import Header from "@/components/Header";
import HeroSlider from "@/components/HeroSlider";
import BrandHorizon from "@/components/BrandHorizon";
import InteractivePillars from "@/components/InteractivePillars";
import Top10Selections from "@/components/Top10Selections";
import LatestArticles from "@/components/LatestArticles";
import TrustSection from "@/components/TrustSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/contexts/LanguageContext";

const Index = () => {
  const { t, language } = useLanguage();

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "The Wise Compass",
    "url": "https://www.thewisecompass.com",
    "logo": "https://www.thewisecompass.com/favicon.png",
    "sameAs": [
      "https://www.instagram.com/the_wise_compass",
      "https://www.linkedin.com/company/thewisecompass"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "The Wise Compass",
    "url": "https://www.thewisecompass.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.thewisecompass.com/explorer?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <SEO 
        title={t.seoTitle}
        description={t.seoDescription}
        locale={language === 'fr' ? 'fr_FR' : 'en_US'}
        alternateLocale={language === 'fr' ? 'en_US' : 'fr_FR'}
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSlider />
          <BrandHorizon />
          <InteractivePillars />
          <Top10Selections />
          <LatestArticles />
          <TrustSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
